var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    color: "#848C9B",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H17C18.654 0 20 1.346 20 3V11C20 12.654 18.654 14 17 14H3C1.346 14 0 12.654 0 11V3C0 1.346 1.346 0 3 0ZM2 3C2 2.449 2.448 2 3 2H17C17.552 2 18 2.449 18 3V4H2V3ZM17 12C17.552 12 18 11.551 18 11V6H2V11C2 11.551 2.448 12 3 12H17ZM5 10H9C9.55 10 10 9.55 10 9C10 8.45 9.55 8 9 8H5C4.45 8 4 8.45 4 9C4 9.55 4.45 10 5 10ZM13 10H15C15.55 10 16 9.55 16 9C16 8.45 15.55 8 15 8H13C12.45 8 12 8.45 12 9C12 9.55 12.45 10 13 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.039677524b13e44cdfe6ed38f4ad4e37.svg";
export { ForwardRef as ReactComponent };